<template>
    <jet-dialog-modal :show="isActive" max-width="lg" @close="closeModal">
        <template #title>
            {{ $t('Add new customer') }}
        </template>

        <template #content>

            <div class="py-4 grid grid-cols-1 gap-6 w-3/4">
                <div>
                    <jet-label for="salutation" :value="$t('Salutation')"/>
                    <jet-select id="salutation" class="mt-1 block w-full"
                                :show-please-choose="true"
                                :items="$page.props.salutations"
                                v-model="form.salutation_id"
                    />
                    <jet-input-error :message="form.errors.salutation_id"
                                     class="mt-2"/>
                </div>
                <div>
                    <jet-label for="internal_uid" :value="$t('Internal customer number')"/>
                    <jet-input id="internal_uid" type="text" class="mt-1 block w-full" placeholder=""
                               ref="internal_uid"
                               v-model="form.internal_uid"/>
                    <jet-input-error :message="form.errors.internal_uid" class="mt-2"/>
                </div>
                <div>
                    <jet-label for="company" :value="$t('Company name')"/>
                    <jet-input id="company" type="text" class="mt-1 block w-full" :placeholder="$t('Company')"
                               ref="company"
                               v-model="form.company"/>
                    <jet-input-error :message="form.errors.company" class="mt-2"/>
                </div>
                <!-- <div>
                    <jet-label for="departement" value="Abteilung in der Firma"/>
                    <jet-input id="departement" type="text" class="mt-1 block w-full" placeholder="Abteilung"
                               ref="departement"
                               v-model="form.departement"/>
                    <jet-input-error :message="form.errors.company" class="mt-2"/>
                </div> -->
                <div>
                    <jet-label for="name" :value="$t('Name')"/>
                    <jet-input id="name" type="text" class="mt-1 block w-full" :placeholder="$t('Name')"
                               ref="name"
                               v-model="form.name"/>
                    <jet-input-error :message="form.errors.name" class="mt-2"/>
                </div>
                <div>
                    <jet-label for="email" :value="$t('E-Mail Address')"/>
                    <jet-input id="email" type="text" class="mt-1 block w-full" :placeholder="$t('customer@email.com')"
                               ref="email"
                               v-model="form.email"/>
                    <jet-input-error :message="form.errors.email" class="mt-2"/>
                </div>
                <div>
                    <label class="flex items-center">
                        <jet-checkbox name="is_superuser" v-model:checked="form.is_superuser"/>
                        <span
                            class="ml-2 text-sm text-gray-600">{{ $t('User has administrator rights') }}</span>
                    </label>
                </div>
                <div>
                    <label class="flex items-center">
                        <jet-checkbox name="is_consultant" v-model:checked="form.is_consultant"/>
                        <span
                            class="ml-2 text-sm text-gray-600">{{ $t('User is a contact for other customers') }}</span>
                    </label>
                </div>
                <div>
                    <label class="flex items-center">
                        <jet-checkbox name="quiet" v-model:checked="form.quiet"/>
                        <span
                            class="ml-2 text-sm text-gray-600">{{ $t('Do not send welcome mail (silent creation)') }}</span>
                    </label>
                </div>
                <div>
                    <label class="flex items-center">
                        <jet-checkbox name="without_onboarding" v-model:checked="form.without_onboarding"/>
                        <span
                            class="ml-2 text-sm text-gray-600">{{ $t('Does not require onboarding (can use the portal directly)') }}</span>
                    </label>
                </div>
            </div>
        </template>

        <template #footer>
            <jet-secondary-button @click="closeModal" :class="{ 'opacity-25': form.processing }"
                                  :disabled="form.processing">
                {{ $t('Cancel') }}
            </jet-secondary-button>

            <jet-button class="ml-2" @click="submitForm" :class="{ 'opacity-25': form.processing }"
                        :disabled="form.processing">
                {{ $t('Save') }}
            </jet-button>
        </template>
    </jet-dialog-modal>
</template>

<script>
import JetDialogModal from '@/Jetstream/DialogModal.vue'
import JetButton from '@/Jetstream/Button.vue'
import JetInput from '@/Jetstream/Input.vue'
import JetInputError from '@/Jetstream/InputError.vue'
import JetSecondaryButton from '@/Jetstream/SecondaryButton.vue'
import JetLabel from "@/Jetstream/Label";
import JetCheckbox from "@/Jetstream/Checkbox";
import JetSelect from "@/Jetstream/Select";

export default {
    name: "CustomerCreationModal",
    emits: ['closed'],
    components: {
        JetButton,
        JetDialogModal,
        JetInput,
        JetInputError,
        JetSecondaryButton,
        JetCheckbox,
        JetLabel,
        JetSelect,
    },
    props: {
        isActive: Boolean,
    },
    data() {
        return {
            form: this.$inertia.form({
                salutation_id: null,
                internal_uid: null,
                name: null,
                departement: null,
                email: null,
                company: null,
                quiet: false,
                without_onboarding: false,
                is_superuser: false,
                is_consultant: false,
            }),
        };
    },
    methods: {
        closeModal() {
            this.$emit('closed');
        },
        submitForm() {
            this.form.post(route('customers.store'), {
                preserveScroll: true,
                // preserveState: false,
                errorBag: 'createCustomer',
                onSuccess: () => (this.resetForm()),
            })
        },
        resetForm() {
            this.form.reset();
        },
    },
}
</script>

<style scoped>

</style>
